export function SpeakerTypingIndicator() {
  return (
    <span className="surf-speaker-whale-typing" aria-live="polite" aria-label="Sta scrivendo">
      <span className="surf-speaker-whale-typing-dot" />
      <span className="surf-speaker-whale-typing-dot" />
      <span className="surf-speaker-whale-typing-dot" />
    </span>
  );
}
